import { render, staticRenderFns } from "./ludimos-brings-in-german-cricket-academys-head-coach-as-its-advisor.vue?vue&type=template&id=37799760&scoped=true&"
var script = {}
import style0 from "./ludimos-brings-in-german-cricket-academys-head-coach-as-its-advisor.vue?vue&type=style&index=0&id=37799760&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37799760",
  null
  
)

export default component.exports